import Box from "@mui/material/Box";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AuthProvider from "modules/Providers/AuthProvider";
import { useThemeContext } from "modules/Providers/ThemeContext";
import { Toaster } from "react-hot-toast";
import { Outlet } from "react-router";
import HeaderTimeBar from "../../sharedComponents/HeaderTimeBar";
import Navigation from "../../sharedComponents/Navigation/Navigation";
import { useDocumentTitle } from "../../sharedHooks/useDocumentTitle";
import Footer from "../Footer/Footer";

const RootLayout = () => {
	const { toggleTheme } = useThemeContext();
	useDocumentTitle();

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<AuthProvider>
				<Toaster
					position="top-right"
					toastOptions={{
						duration: 4000,
						style: {
							background: "#363636",
							color: "#fff",
						},
					}}
				/>
				<Box
					sx={{
						minHeight: "min(100svh, 100vh)",
						width: "100%",
						display: "flex",
						flexDirection: "column",
						overflow: "hidden",
					}}
				>
					<Navigation onToggleTheme={toggleTheme} />
					<HeaderTimeBar />
					<Box
						component="main"
						sx={{
							flexGrow: 1,
							display: "flex",
							flexDirection: "column",
							px: { xs: 1, sm: 2 },
							pt: { xs: 1, sm: 2 },
							pb: { xs: 2, sm: 3 },
							maxWidth: 1240,
							width: "100%",
							marginInline: "auto",
							gap: { xs: 1, sm: 2 },
						}}
					>
						<Outlet />
					</Box>
					<Footer />
				</Box>
			</AuthProvider>
		</LocalizationProvider>
	);
};

export default RootLayout;
